import { Component, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import WorksPage from "@/pages/WorksPage";
import ServicesPage from "@/pages/ServicesPage";
import TeamPage from "@/pages/TeamPage";
import ContactPage from "@/pages/ContactPage";
import CalendarPage from "@/pages/CalendarPage";
import ProjectDetail from "@/pages/ProjectDetail";
import Admin from "@/pages/Admin";
import { initLenis } from "@/lib/scroll";
import { LangContext } from "@/lib/i18n";

const queryClient = new QueryClient();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-8">
          <p className="text-[#f5f5f5] font-zh">页面出错了，请刷新重试。</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("dfe-lang") || "zh");
  useEffect(() => {
    localStorage.setItem("dfe-lang", lang);
  }, [lang]);
  useEffect(() => initLenis(), []);
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/works" element={<WorksPage />} />
              <Route path="/works/:id" element={<ProjectDetail />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors toastOptions={{ style: { borderRadius: 0 } }} />
        </ErrorBoundary>
      </QueryClientProvider>
    </LangContext.Provider>
  );
}

export default App;
